import { VerticalContainer } from '@american-autonomy/rantizo-ui';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const SubscriptionSummaryCardContainer: FunctionComponent<Props> = ({
    children,
    className = '',
    testId = TEST_ID
}) => (
    <VerticalContainer
        className={`${className} ${styles.subscriptionSummaryCardContainer}`}
        testId={testId}
    >
        {children}
    </VerticalContainer>
);

export default SubscriptionSummaryCardContainer;
